import React from 'react';

import styles from '../fieldStyles';

import EditableImage from 'buyside/components/presentation/EditableImage/editableImage';

const ImageField = ({
  field: { name },
  form: { setFieldValue, isSubmitting },
  label,
  note,
  ...editableImageProps
}) => {
  const saveImage = ({ cropData, imageData, croppedImageData, removeImage }) => {
    if (removeImage) {
      setFieldValue(`${name}.removeImage`, true);
      setFieldValue(`${name}.imageData`, editableImageProps.defaultImage);
      setFieldValue(`${name}.croppedImageData`, editableImageProps.defaultImage);
    } else {
      setFieldValue(`${name}.removeImage`, false);
      setFieldValue(`${name}.cropData`, JSON.stringify(cropData));
      if (imageData) setFieldValue(`${name}.imageData`, imageData);
      setFieldValue(`${name}.croppedImageData`, croppedImageData);
    }
    return Promise.resolve();
  };
  return (
    <div className={styles.fieldContainer}>
      <label className={styles.fieldLabel}>{label}</label>
      <EditableImage isEditable={!isSubmitting} saveImage={saveImage} {...editableImageProps} />
      {note && <div className={styles.fieldNote}>{note}</div>}
    </div>
  );
};

export default ImageField;
